import { File } from '@/typings/api/File'
import { createDownload, DELETE } from '@/helpers/enums/table-actions'


const getFileUrl = (data: File) => data.raw_file.url

export const TABLE_ACTIONS = Object.freeze([
  createDownload(getFileUrl),
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
  },
  /*
  {
    text: 'Размер',
    value: 'raw_file.size',
    width: 100,
    sortable: false,
  },
  */
])
